import { GridCallbackDetails, useGridApiRef } from '@mui/x-data-grid-premium';
import { useBulkEditDataGridContext } from './bulk-edit-data-grid.context';
import { IncDataGridProps } from '../inc-data-grid.component';
import IncDataGridWrapee from '../inc-data-grid-wrapee/inc-data-grid-wrapee.component';

const BulkEditDataGrid = ({
  onRowSelectionModelChange,
  ...rest
}: IncDataGridProps) => {
  const apiRef = useGridApiRef();
  const { setFirstSelectedGridRowData, firstSelectedGridRowData } =
    useBulkEditDataGridContext();

  return (
    <IncDataGridWrapee
      apiRef={apiRef}
      onRowSelectionModelChange={(
        item: string[],
        details: GridCallbackDetails,
      ) => {
        const selectedRowsMap = apiRef.current.getSelectedRows();
        const firsSelectedKey = selectedRowsMap.keys().next().value;
        const firsSelectedValue = selectedRowsMap.values().next().value;

        if (firstSelectedGridRowData?.key !== firsSelectedKey)
          setFirstSelectedGridRowData({
            key: firsSelectedKey,
            value: firsSelectedValue,
          });

        onRowSelectionModelChange?.(item, details);
      }}
      {...rest}
    />
  );
};

export default BulkEditDataGrid;
